import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=9af8a77a&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9af8a77a')) {
      api.createRecord('9af8a77a', component.options)
    } else {
      api.reload('9af8a77a', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=9af8a77a&", function () {
      api.rerender('9af8a77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manager/admin.vue"
export default component.exports